"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Import = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 12,
  viewBox: "0 0 16 12",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.173 10.819C1.955 11.606 2.897 12 4 12h2.75V8.078H4L8 3l4 5.078H9.25V12h3.477a3.11 3.11 0 002.319-.984c.636-.656.954-1.454.954-2.391 0-.862-.276-1.616-.827-2.26a3.181 3.181 0 00-1.224-.897c-.47-.191-.847-.602-.922-1.103a5.07 5.07 0 00-1.418-2.837C10.62.509 9.419 0 8 0a4.878 4.878 0 00-3.09 1.069 5.04 5.04 0 00-1.635 2.219 1.325 1.325 0 01-.76.752c-.661.26-1.215.688-1.66 1.285A4.241 4.241 0 000 7.931c0 1.138.391 2.1 1.173 2.888z",
  className: "fill"
}));
var _default = exports.default = Import;